var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "decorative-divider" }),
    _vm._v(" "),
    _c("div", { staticClass: "bank-details" }, [
      _c("h2", [_vm._v("Payment details")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.bookingRegion === "gb"
        ? _c("div", [
            _c("p", [_vm._v("Waterhouse Business Centre")]),
            _vm._v(" "),
            _c("p", [_vm._v("Chelmsford, Essex. CM1 2QE")]),
          ])
        : _c("div", [
            _c("p", [_vm._v("Level 4, 33 King William Street")]),
            _vm._v(" "),
            _c("p", [_vm._v("Adelaide, 5000")]),
          ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _vm.selectedPaymentAmountsAreNotSent
          ? _c(
              "ladda-button",
              {
                staticClass: "btn btn-payment",
                attrs: { type: "submit", click: _vm.handlePaymentSentCallback },
              },
              [
                _c("i", { staticClass: "fa fa-send" }),
                _vm._v("\n      Payment Sent\n    "),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.$userIsAdmin
      ? _c("ul", { staticClass: "large-checklist" }, [
          _c("li", [
            _c("div", { staticClass: "checkbox checkbox-primary" }, [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  id: "checkbox_payment_received",
                  disabled: _vm.processingPaymentsReceived,
                },
                on: { click: _vm.handlePaymentReceivedCallback },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "checkbox_payment_received" } }, [
                _vm._v("\n          Payment Received\n        "),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Pickstar Pty Ltd")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }